<script>
import Filtros from '@/components/pesquisa/VFiltrosPesquisaPlacas'
import Mostrar from '@/components/pesquisa/VMostraPlacas'
import { mapState } from "vuex"

export default {
  name: "PesquisaPlacas",
  components: {
    Filtros,
    Mostrar
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      pp: state => state.modulePesquisa.buscarpesquisaplacas,
      pesquisaplaca: state => state.modulePesquisa.pesquisaplaca,
      pesquisaqtdplacas: state => state.modulePesquisa.pesquisaqtdplacas,
      pagesize: state => state.modulePesquisa.pagesize
    }),  
  },
  methods: {
    buscarFiltro (pagina) {
      if (this.pp.selecionadoPontos && this.pp.placaValido) {
        var r = this;
        this.$store.dispatch("PESQUISAPLACASPG", {
            usuario: r.usuario,
            pesquisa: r.pp,
            cidade: r.user.cidade,
            page: pagina,
            pagesize: r.pagesize
        }).then(((result) => {
            if (0 == result.length) {
              r.$swal({
                title: "Resultada da Pesquisa",
                html: "Não foram encontrado",
                icon: "warning"
              })
            } else {
              r.$store.dispatch("PESQUISAQTDPLACAS", {
                usuario: r.usuario,
                pesquisa: r.pp,
                cidade: r.user.cidade
              }).then((function() {
                var o = parseInt(Math.ceil(r.pesquisaqtdplacas / r.pagesize, 10));
                r.$store.dispatch("PESQUISAPLACASPGBK", {
                    usuario: r.usuario,
                    pesquisa: r.pp,
                    cidade: r.user.cidade,
                    pagebk: pagina,
                    pagesize: r.pagesize
                }), "2" != o && (o = 2, r.$store.dispatch("PESQUISAPLACASPGBK", {
                    usuario: r.usuario,
                    pesquisa: r.pp,
                    cidade: r.user.cidade,
                    pagebk: pagina,
                    pagesize: r.pagesize
                }))
            }))
            }
        }))
      } else this.pp.selecionadoPontos || this.$swal.fire({
          title: "Pontos",
          text: "Selecione um ponto!!!",
          icon: "warning",
        }), this.pp.placaValido || this.$swal.fire({
          title: "Placa",
          text: "Placa errada",
          icon: "error",
        })
    }
  },
}
</script>

<template>
  <div style="background-color:#6c7a89;">
    <Filtros :buscarFiltro="buscarFiltro"/>
    <Mostrar />
  </div>
</template>